import { render, staticRenderFns } from "./PrecoMinimo.vue?vue&type=template&id=3f49a2a5&"
import script from "./PrecoMinimo.vue?vue&type=script&lang=js&"
export * from "./PrecoMinimo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports